// @vendors
import React, { useEffect } from 'react'
import Highcharts from 'highcharts'

// @styles
import './ChartVentasDiarias.css'

// @utils
import { setearMiles } from 'util/funciones'
import { formatearFecha } from 'util/formatDate'
import moment from 'moment'
interface Props {
    data: any[]
    type: 'line' | 'area'
    color?: string
    length: 1 | 2 | 3
    updateData: number
}

// const startDate = moment().subtract(1, 'months');
const ChartVentasDiarias = ({ data, type, color, length, updateData }: Props) => {
    const today = moment().startOf('day') // Día actual (último punto de la serie)
    // Construye pares [timestamp, valor] anclando el ÚLTIMO punto al día de hoy
    // y retrocediendo un día por cada valor. Evita el descuadre por meses de 28/29/30/31 días.
    const construirPuntos = (valores: any[]) => {
        const lista = valores || []
        const total = lista.length

        return lista.map((valor: any, index: number) => {
            const numero = valor === null || valor === undefined || valor === '' ? NaN : Number(valor)
            const x = today
                .clone()
                .subtract(total - 1 - index, 'days')
                .startOf('day')
                .valueOf()
            return [x, isNaN(numero) ? null : numero]
        })
    }

    const crearGrafica = () => {
        const options = {
            chart: {
                type: type,
                series: {
                    color: color
                }
            },
            title: {
                text: ''
            },
            yAxis: {
                title: {
                    text: ''
                },
                /*  labels: {
                     format: '${value}',
                 }, */

                labels: {
                    formatter: (label: any) => '$' + setearMiles(label.value ?? 0),

                    tooltip: {
                        formatter(this: Highcharts.TooltipFormatterContextObject) {
                            return ' % ' + setearMiles(this.point.y ?? 0)
                        }
                    }
                }
            },
            xAxis: {
                type: 'datetime',
                title: {
                    style: { color: 'black', fontSize: '1.2rem' }
                },
                tickInterval: 86400000, // Un día en milisegundos
                max: today.clone().endOf('day').valueOf()
            },
            plotOptions: {
                series: {
                    marker: {
                        enabled: false
                    }
                }
            },
            series: (data ?? []).map(item => ({
                name: item.name,
                color: color,
                data: construirPuntos(item.data)
            })),
            tooltip: {
                formatter(this: Highcharts.TooltipFormatterContextObject) {
                    return `  $ ${setearMiles(this.point.y ?? 0)}  <br/>  ${formatearFecha(new Date(this.point.x), 'DD/MM/YYYY')}`
                }
            }
        }
        Highcharts.chart('container__chartVentasDiarias', (options as any) as Highcharts.Options)
    }

    useEffect(() => {
        crearGrafica()
    }, [updateData, data])

    return (
        <>
            <div id="container__chartVentasDiarias" className="col-md-12 mx-auto"></div>
            {/* <FiltrosOperation onChange={(selection: number) => setSelectionOperation(selection)} prevActive={selectionOperation} /> */}
        </>
    )
}

export default ChartVentasDiarias

